<template>
  <div>
    <div class="userInfor">
      <span>证书信息</span>
      <!-- <span v-else>基本信息</span> -->
      <div class="btn">
        <el-button size="small" type="primary" style="margin-top: 12px" @click="prev">上一步</el-button>
        <el-button size="small" type="warning" style="margin-top: 12px"
          @click="submit('ruleFormInfo')">保存并提交</el-button>
      </div>
    </div>
    <div class="infomation">
      <div class="titleheader"><span style="color: red;margin-right:2px;">*</span>创新管理师及等同证书</div>
      <div class="infomation_item">
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :row-key="getRowKeys"
          @selection-change="handleSelectionChange" empty-text="请确认是否取得“创新管理师及等同证书”或邮箱咨询：“info@imspp.org.cn”">
          <el-table-column type="selection" width="55" :selectable="selected" :reserve-selection="seleCheck">
          </el-table-column>
          <el-table-column label="资质编号" width="240" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.cerNum }}</template>
          </el-table-column>
          <el-table-column prop="surname" label="姓名" width="150" show-overflow-tooltip> </el-table-column>
          <!-- <el-table-column prop="unit_name" label="所属单位" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column prop="permissionTime" label="颁证日期" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ scope.row.permissionTime.slice(0, 10) }}</span></template>
          </el-table-column>
          <el-table-column prop="expirationTime" label="到期日期" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ scope.row.expirationTime.slice(0, 10) }}</span></template>
          </el-table-column>
          <el-table-column label="资质状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0"><span class="red">失效（已到期）</span></span>
              <span v-if="scope.row.status == 1"><span class="blue">有效（即将到期）</span></span>
              <span class="green" v-if="scope.row.status == 2">有效</span>
            </template></el-table-column>
        </el-table>
        <!-- :show-file-list="false" -->
        <el-form style="width: 100%; margin: 20px 0">
          <el-form-item label="创新管理师等同证书：">
            <el-upload class="upload-demo" action="/index/upload" :on-remove="(file) => handleRemovess(file, 1)"
              :on-preview="(file) => handlePreview(file)" :multiple="false" accept=".pdf,.png,.jpg,.bmp,.jpeg"
              :file-list="fileLists" :before-upload="(file) => beforeAvatarUploadss(file, 1)"
              :http-request="(file) => submitUploadtables(file, 1)">
              <el-button size="small" type="primary" plain>
                <i class="el-icon-upload2"></i> 点击上传</el-button>
              <el-button @click.stop="lookDetail" type="text">查看样例</el-button>
              <span slot="tip" class="el-upload__tip">&nbsp;Amplify日语、韩语、法语、西班牙语等其他语种结业证书具有同等效力，支持扩展名：.pdf .png .jpg
                .bmp
                .jpeg</span>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div class="titleheader"><span style="color: red;margin-right:2px;">*</span>创新管理师2级</div>
      <div class="infomation_item">
        <el-table ref="multipleTable2" :data="tableData2" tooltip-effect="dark" style="width: 100%"
          :row-key="getRowKeys" @selection-change="handleSelectionChange2"
          empty-text="请确认是否取得“创新管理师2级”或邮箱咨询：“info@imspp.org.cn”">
          <el-table-column type="selection" width="55" :reserve-selection="seleCheck" :selectable="selected">
          </el-table-column>
          <el-table-column label="资质编号" width="240" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.cerNum }}</template>
          </el-table-column>
          <el-table-column prop="surname" label="姓名" width="150" show-overflow-tooltip> </el-table-column>
          <!-- <el-table-column prop="unit_name" label="所属单位" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column prop="permissionTime" label="颁证日期" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ scope.row.permissionTime.slice(0, 10) }}</span></template>
          </el-table-column>
          <el-table-column prop="expirationTime" label="到期日期" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ scope.row.expirationTime.slice(0, 10) }}</span></template>
          </el-table-column>
          <el-table-column label="资质状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0"><span class="red">失效（已到期）</span></span>
              <span v-if="scope.row.status == 1"><span class="blue">有效（即将到期）</span></span>
              <span class="green" v-if="scope.row.status == 2">有效</span>
            </template></el-table-column>
        </el-table>
        <!-- <el-form style="width: 100%; margin: 20px 0">
          <el-form-item label="创新管理师2级证书文件:">
            <el-upload class="upload-demo" action="/index/upload" :on-remove="(file) => handleRemovess(file, 2)"
              :multiple="false" accept=".pdf,.png,.jpg,.bmp,.jpeg" :file-list="fileLists2"
              :before-upload="(file) => beforeAvatarUploadss(file, 2)"
              :http-request="(file) => submitUploadtables(file, 2)">
              <el-button size="small" type="primary" plain>
                <i class="el-icon-upload2"></i> 点击上传</el-button>
              <span slot="tip" class="el-upload__tip">请上传与创新管理师等同证书，支持扩展名：.pdf .jpg</span>
            </el-upload>
          </el-form-item>
        </el-form> -->
      </div>
      <div class="titleheader" v-if="flag && flag == 1"><span style="color: red;margin-right:2px;">*</span>游戏培训证书</div>
      <div class="infomation_item" v-if="flag && flag == 1">
        <el-table ref="multipleTable3" :data="tableDataGram" tooltip-effect="dark" style="width: 100%"
          :row-key="getRowKeys" @selection-change="handleSelectionGram"
          empty-text="请确认是否取得“游戏培训证书”或邮箱咨询：“info@imspp.org.cn”">
          <el-table-column type="selection" width="55" :reserve-selection="seleCheck" :selectable="selected">
          </el-table-column>
          <el-table-column label="资质编号" width="240" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.cerNum }}</template>
          </el-table-column>
          <el-table-column prop="surname" label="姓名" width="150" show-overflow-tooltip> </el-table-column>
          <!-- <el-table-column prop="unit_name" label="所属单位" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column prop="permissionTime" label="颁证日期" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ scope.row.permissionTime.slice(0, 10) }}</span></template>
          </el-table-column>
          <el-table-column prop="expirationTime" label="到期日期" show-overflow-tooltip>
            <template slot-scope="scope"><span>{{ scope.row.expirationTime.slice(0, 10) }}</span></template>
          </el-table-column>
          <el-table-column label="资质状态" show-overflow-tooltip>
            <!-- 0,1,2 过期，临近，正常 -->
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0"><span class="red">失效（已到期）</span></span>
              <span v-if="scope.row.status == 1"> <span class="blue">有效（即将到期）</span></span>
              <span class="green" v-if="scope.row.status == 2">有效</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-form style="width: 100%; margin: 20px 0">
          <el-form-item label="游戏培训证书文件:">
            <el-upload class="upload-demo" action="/index/upload" :on-remove="(file) => handleRemovess(file, 3)"
              :multiple="false" accept=".pdf,.png,.jpg,.bmp,.jpeg" :file-list="fileLists3"
              :before-upload="(file) => beforeAvatarUploadss(file, 3)" :on-preview="(file) => handlePreview(file)"
              :http-request="(file) => submitUploadtables(file, 3)">
              <el-button size="small" type="primary" plain>
                <i class="el-icon-upload2"></i> 点击上传</el-button>
              <span slot="tip" class="el-upload__tip">请上传与创新管理师等同证书，支持扩展名：.pdf .png .jpg .bmp .jpeg</span>
            </el-upload>
          </el-form-item>
        </el-form> -->
      </div>
      <div class="titleheader"><span style="color: red;margin-right:2px;">*</span>相关资料</div>
      <div class="infomation_item">
        <el-form style="width: 100%; padding: 0 40px 0 0">
          <!-- <el-form-item label="培训能力证明：" label-width="120px">
            <el-upload class="upload-demo" action="/index/upload" :on-remove="(file) => handleRemovess(file, 4)"
              :multiple="false" accept=".pdf,.png,.jpg,.bmp,.jpeg" :file-list="fileLists4"
              :before-upload="(file) => beforeAvatarUploadss(file, 4)" :on-preview="(file) => handlePreview(file)"
              :http-request="(file) => submitUploadtables(file, 4)">
              <el-button size="small" type="primary" plain>
                <i class="el-icon-upload2"></i> 点击上传</el-button>
              <span slot="tip" class="el-upload__tip" style="font-size: 13px">
                请上传培训能力证明文件，支持扩展名：.pdf .png .jpg .bmp .jpeg
              </span>
            </el-upload>
          </el-form-item> -->
          <el-form-item label="附件：" label-width="80px">
            <el-upload class="upload-demo" action="/index/upload" :on-remove="(file) => handleRemovess(file, 5)"
              :multiple="false" accept=".pdf,.png,.jpg,.bmp,.jpeg" :file-list="fileLists5"
              :on-preview="(file) => handlePreview(file)" :before-upload="(file) => beforeAvatarUploadss(file, 5)"
              :http-request="(file) => submitUploadtables(file, 5)">
              <el-button size="small" type="primary" plain>
                <i class="el-icon-upload2"></i> 点击上传</el-button>
              <span slot="tip" class="el-upload__tip" style="font-size: 13px">
                请上传培训能力证明文件（如培训师资质证书等），支持扩展名：.pdf .png .jpg .bmp .jpeg
              </span>
            </el-upload>
          </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible" width="80%">
          <!-- <img width="100%" :src="dialogImageUrl" alt="" /> -->
          <img style="width: 100%;height: 100%;" :src="lookFile" alt="" v-if="lookFile" />
          <iframe v-if="pdfLook" :src="pdfLook" toolbar="0" style="
                      border: none;
                      width: 100%;
                      min-height:600px;
                      margin: 0 auto;
                    "></iframe>
        </el-dialog>
        
      </div>
    </div>
  </div>
</template>
<script>
import { getPicture, getDict } from "@/api/getinform/getinform.js";
import { getDictInfoNew, certificateDetail, queryList } from "@/api/api.js";
import axios from "axios";
import { data } from "jquery";
export default {
  name: "",
  components: {},
  props: {
    flag: Number,
    activeNum: Number,
    idsession: String
  },
  data() {
    let crenumCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入案子量"));
      } else {
        const reg = /^([1-9]{1}[0-9]{0,4})$/;
        if (!reg.test(value)) {
          const msg = rule.msg ? rule.msg : "请输入1~99999之间的数字";
          return callback(new Error(msg));
        } else {
          return callback();
        }
      }
    };
    return {
      tableData: [],
      tableData2: [],
      tableDataGram: [],
      seletList: [],
      seletList2: [],
      seletList3: [],
      isUnitAgree: "",
      showchange: false,
      ruleForm: {
        imageUrl: "",
        annexFile: {}, //资质
        cerName: "",
        cerType: "",
      },
      dataFormFile: {
        name: "",
        file: null,
      },
      annexFileFu: [],
      formLabelWidth: "150px",
      dialogImageUrl: "",
      dialogVisible: false,
      pdfLook: "",
      lookFile: "",
      fileList: [],
      fileLists: [],
      fileLists2: [],
      fileLists3: [],
      fileLists4: [],
      fileLists5: [],
      fileListData: [],
      dialogFormVisible: false,
      form: {},

      istype: "1",
      dataFrom: [],
      id: 1,
      imageUrl: "",
      showPic: false,
      status: "",
      qualificaType: [],
      userId: "",
      isEdit: "",
      datalist: [],
      seleCheck: false,
      listarr: {
        arr: [],
        arr3: [],
        arr2: [],
      },
      delAnnexFileIdList: [],
      userInfoid: this.$route.query.userInfos,
      istime: "",
      istimes: "",
      istimesNo: "",
      istimeNo: "",
      // region: "",
    };
  },
  computed: {},
  watch: {
    "$store.state.region"(newValue) {
      // console.log(newValue, "region");
      this.istype = newValue;
    },
    activeNum(val) {
      if (this.userInfoid == null) {
        this.userInfoid = sessionStorage.getItem('userInfoid')
      }
      if (val == 3) {
        if (this.userInfoid) {
          this.getInfo();
        }
      }
    },
    // idsession(val) {
    //   console.log(val,this.activeNum,'123')
    //   if (val && this.activeNum == 3) {
    //     this.userInfoid = val
    //     this.getInfo()
    //   }
    // }
  },
  async created() {
    await getDictInfoNew("ZZDJ").then((res) => {
      // console.log(res);
      this.qualificaType = res.data;
    });
  },
  mounted() {
    if (this.userInfoid) {
      this.getInfo();
    }
  },
  methods: {
    selected(row, index) {
      if (row.status == 0) {
        return false //不可勾选
      } else {
        return true; //可勾选
      }
    },
    getRowKeys(row) {
      return row.id;
    },
    getList() {
      this.tableData = [];
      this.tableDataGram = [];
      this.tableData2 = [];
      this.seletList = []
      this.seletList2 = []
      this.seletList3 = []
      queryList().then((res) => {
        res.data.map((item) => {
          if (item.cerType == "1") {
            this.tableData.push(item);
            // this.istime = this.isWithinThreeMonths(item.expirationTime)
          } else if (item.cerType == "7") {
            // this.$refs.multipleTable3.toggleRowSelection(item, true);
            this.tableDataGram.push(item);
            if (this.flag == 1) {
              this.istimes = item.status
            }
          } else if (item.cerType == "8") {
            this.tableData2.push(item);
            this.istime = item.status
            // this.$refs.multipleTable2.toggleRowSelection(item, true);
          }
          this.tableData.map(item => {
            // if(item.status != 0){
            this.$refs.multipleTable.toggleRowSelection(item, true);
            // }
          })
          this.tableData2.map(item => {
            // if (item.status != 0) {
              this.$refs.multipleTable2.toggleRowSelection(item, true);
            // }
          })
          if (this.flag == 1) {
            this.tableDataGram.map(item => {
              // if (item.status != 0) {
                this.$refs.multipleTable3.toggleRowSelection(item, true);
              // }
            })
          }

        });
      });
    },
    getInfo() {
      this.tableData = [];
      this.tableDataGram = [];
      this.tableData2 = [];
      this.seletList = []
      this.seletList2 = []
      this.seletList3 = []
      if (this.userInfoid == null) {
        this.userInfoid = sessionStorage.getItem('userInfoid')
      }
      certificateDetail(
        this.$qs.stringify({ id: this.userInfoid })
      ).then((res) => {
        if (res.code == "1000") {
          if (
            res.data.annexFileVoList.length ||
            res.data.aptitudeApplyPersonCertificateList.length
          ) {
            this.isEdit = "1";
            // res.data.aptitudeApplyPersonCertificateList.map(item => {
            //   if (item.cerType == "1") {
            //     this.tableData.push(item);
            //   } else if (item.cerType == "7") {
            //     // this.$refs.multipleTable3.toggleRowSelection(item, true);
            //     this.tableDataGram.push(item);
            //   } else if (item.cerType == "8") {
            //     this.tableData2.push(item);
            //     // this.$refs.multipleTable2.toggleRowSelection(item, true);
            //   }
            // })
            this.getList();
            // this.datalist = res.data.aptitudeApplyPersonCertificateList;
          } else {
            this.isEdit = "0";
            this.getList();
          }
          if (!res.data.annexFileVoList.length) return
          this.fileLists3 = [];
          this.fileLists = [];
          this.fileLists2 = [];
          this.fileLists4 = [];
          this.fileLists5 = [];
          res.data.annexFileVoList.map((item) => {
            item.name = item.annexName;
            item.fileName = item.annexName;
            if (item.annexType == "E") {
              // 游戏培训证书
              this.fileLists3.push(item);
            } else if (item.annexType == "F") {
              //创新管理师及等同证书
              this.fileLists.push(item);
            } else if (item.annexType == "G") {
              // 创新管理师2级
              this.fileLists2.push(item);
            } else if (item.annexType == "H") {
              // 培训能力
              this.fileLists4.push(item);
            } else if (item.annexType == 9) {
              // 其他
              this.fileLists5.push(item);
            }
          });
        }
      });
    },
    // 创新管理师
    handleSelectionChange(value) {
      // console.log(value);
      this.seletList = value;
    },
    // 创新管理师2级
    handleSelectionChange2(value) {
      // console.log(value);
      this.seletList2 = value;
    },
    // 游戏
    handleSelectionGram(value) {
      // console.log(value);
      this.seletList3 = value;
    },

    beforeAvatarUploadss(file, id) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type == "image/bmp" ||
        file.type === "application/pdf";
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (file.type === "application/pdf" && file.size / 1024 / 1024 > 20) {
        this.$message.error("上传附件大小不能超过 20MB!");
        return false;
      }
      if (!isJPG) {
        this.$message.error("上传相关附件只能是 jpg、png、jpeg、bmp、pdf格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
      }
      let sameFilename = "";
      if (id == 1) {
        sameFilename = this.fileLists.filter(
          (item) => item.fileName === file.name
        );
      } else if (id == 2) {
        sameFilename = this.fileLists2.filter(
          (item) => item.fileName === file.name
        );
      } else if (id == 3) {
        sameFilename = this.fileLists3.filter(
          (item) => item.fileName === file.name
        );
      } else if (id == 4) {
        sameFilename = this.fileLists4.filter(
          (item) => item.fileName === file.name
        );
      } else if (id == 5) {
        sameFilename = this.fileLists5.filter(
          (item) => item.fileName === file.name
        );
      }
      if (sameFilename.length > 0) {
        this.$message.warning(`文件${file.name}已经上传，此次跳过`);
        return false;
      }
      if (file.name.length > 50) {
        this.$message.error("文件名称不能超过50位");
        return false;
      }
      return isJPG && isLt2M;
    },

    // 显示上传单位确认函
    changeshow(val) {
      if (val == 1) {
        this.showchange = true;
      } else if (val == 2) {
        this.showchange = false;
      }
    },
    prev() {
      let active = 2;
      this.$emit("prev", active);
    },
    download() {
      let baseUrl = window.global_config.BASE_URL;
      axios({
        url: `${baseUrl}/v1/api/patentPerson/downloadAcknowledgmentTemplates`,
        method: "post",
        responseType: "blob",
        data: {},
      })
        .then((res) => {
          if (res.status == 200) {
            this.disabled = false;
            if (!res.headers["content-disposition"]) {
              this.$message.error("暂无权限下载!");
            }
            // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
            const BLOB = res.data;
            // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
            const fileReader = new FileReader();
            // 开始读取指定的Blob中的内容。读取完成result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
            fileReader.readAsDataURL(BLOB);
            // 处理load事件，该事件在读取操作完成时触发
            fileReader.onload = (event) => {
              let a = document.createElement("a");
              // 赋值下载的文件名
              let fileNames = res.headers["content-disposition"]
                .split(";")[1]
                .split("=")[1]; //获取到Content-Disposition;filename
              // let fileNames = "资质信息";
              a.download = `${decodeURI(fileNames)}`;
              a.href = event.target.result;
              document.body.appendChild(a);
              a.click();
            };
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(console.log("error"));
    },
    lookDetail() {
      this.dialogVisible = true;
      this.lookFile = require('@/assets/filePic.png')
    },
    handlePreview(file) {
      console.log(file)
      let baseUrl = window.global_config.BASE_URL;
      this.dialogVisible = true;
      this.pdfLook = ""
      this.lookFile = ""
      // let id = "13B118A7FB91451DA6A3C2EDAA14128D";
      // window.open(`${baseUrl}/v1/api/file/${file.id}/view`);
      if (file.name.includes("pdf") || file.name.includes("PDF")) {
        this.pdfLook = `${baseUrl}/v1/api/file/${file.id}/view`;
      } else {
        this.lookFile = `${baseUrl}/v1/api/file/${file.id}/view`;
      }
    },
    delFile(row) {
      console.log(row)
    },
    // 相关附件
    submitUploadtables(file, id) {
      let image = new FormData();
      image.append("file", file.file);

      this.ruleForm.imageUrl = "";

      if (id == 1) {
        image.append("type", "F");
      } else if (id == 2) {
        image.append("type", "G");
      } else if (id == 3) {
        image.append("type", "E");
      } else if (id == 4) {
        image.append("type", "H");
      } else if (id == 5) {
        image.append("type", "9");
      }
      getPicture(image).then((res) => {
        if (res.code == "1000") {
          res.data.name = res.data.fileName;
          if (id == 1) {
            this.fileLists.push(res.data);
          } else if (id == 2) {
            this.fileLists2.push(res.data);
          } else if (id == 3) {
            this.fileLists3.push(res.data);
          } else if (id == 4) {
            this.fileLists4.push(res.data);
          } else if (id == 5) {
            this.fileLists5.push(res.data);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 相关附件-删除
    handleRemovess(file, id) {
      if (file && file.status == "success") {
        if (id == 1) {
          this.fileLists.map((item, index) => {
            if (item.name == file.name) {
              this.fileLists.splice(index, 1);
              this.delAnnexFileIdList.push(item.id);
            }
          });
        } else if (id == 2) {
          this.fileLists2.map((item, index) => {
            if (item.name == file.name) {
              this.fileLists2.splice(index, 1);
              this.delAnnexFileIdList.push(item.id);
            }
          });
        } else if (id == 3) {
          this.fileLists3.map((item, index) => {
            if (item.name == file.name) {
              this.fileLists3.splice(index, 1);
              this.delAnnexFileIdList.push(item.id);
            }
          });
        } else if (id == 4) {
          this.fileLists4.map((item, index) => {
            if (item.name == file.name) {
              this.fileLists4.splice(index, 1);
              this.delAnnexFileIdList.push(item.id);
            }
          });
        } else if (id == 5) {
          this.fileLists5.map((item, index) => {
            if (item.name == file.name) {
              this.fileLists5.splice(index, 1);
              this.delAnnexFileIdList.push(item.id);
            }
          });
        }
      }
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    isWithinThreeMonths(date) {
      const today = new Date();
      const threeMonthsAgo = new Date(today);

      // 将今天的日期减去三个月
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

      // 将给定的日期转换为Date对象
      const givenDateObj = new Date(date);
      // 比较给定日期是否在三个月内
      return givenDateObj >= threeMonthsAgo && givenDateObj <= today;
    },
    isWithinThreeMonthss(date) {
      const todaya = new Date();
      const threeMonthsAgos = new Date(todaya);

      // 将今天的日期+三个月
      threeMonthsAgos.setMonth(threeMonthsAgos.getMonth() + 3);

      // 将给定的日期转换为Date对象
      const a = new Date(date);
      return a <= threeMonthsAgos && a >= todaya;
    },
    // 提交
    submit(ruleFormInfo) {
      // if (this.tableData.length != 0) {
      //   if (this.tableData[0].status == 0) {
      //     this.$confirm('您的创新管理师及等同证书已到期，请及时续证。谢谢。', '提示', {
      //       confirmButtonText: '确定',
      //       showCancelButton: false,
      //     }).then(() => {
      //       console.log(1)
      //       a = true
      //     })
      //   }else{
      //     a  = true
      //   }
      // }
      if (this.tableData2.length != 0 && this.istime == 0) {
        this.$confirm('您的创新管理师2级证书已到期，请及时续证。谢谢。', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
        }).then(() => {
          if (this.flag == 1 && this.seletList3.length != 0 && this.istimes == 0) {
            this.$confirm('您的游戏培训证书已到期，请及时续证。谢谢。', '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
            }).then(() => {
              return false
            })
            return
          }
        })
        return
      }
      if (this.flag == 1 && this.seletList3.length != 0 && this.istimes == 0) {
        this.$confirm('您的游戏培训证书已到期，请及时续证。谢谢。', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
        }).then(() => {
          return false
        })
        return
      }
     
      if (this.seletList.length == 0&& this.fileLists.length == 0) {
        this.$message.warning("请选择有效的创新管理等同证书");
        return;
      }
      if (this.tableData.length == 0 && this.fileLists.length == 0) {
        this.$message.warning("请上传创新管理等同证书");
        return;
      }
      if (this.seletList2.length == 0) {
        this.$message.warning("请选择有效的创新管理师2级证书");
        return;
      }
      if (this.flag == 1 && this.seletList3.length == 0) {
        this.$message.warning("请选择有效创新管理实训主持人证书");
        return
      }
      if (this.fileLists5.length == 0) {
        this.$message.warning("请上传培训能力证明文件");
        return
      }

      if (this.seletList2.length != 0 && this.istime == 1) {
        this.$confirm('您的创新管理师2级证书即将到期，请提前续证。谢谢。', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
        }).then(() => {
          if (this.flag == 1 && this.seletList3.length != 0 && this.istimes == 1) {
            this.$confirm('您的游戏培训证书即将到期，请提前续证。谢谢。', '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
            }).then(() => {
              this.infoSubmit()
            })
          } else {
            this.infoSubmit()
          }
        })
      } else if (this.flag == 1 && this.seletList3.length != 0 && this.istimes == 1) {
        this.$confirm('您的游戏培训证书即将到期，请提前续证。谢谢。', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
        }).then(() => {
          this.infoSubmit()
        })
      } else {
        this.infoSubmit()
      }

    },
    infoSubmit() {
      let arrayList = {
        lists: this.fileLists,
        lists2: this.fileLists2,
        lists3: this.fileLists3,
        lists4: this.fileLists4,
        lists5: this.fileLists5,
        seletList: this.seletList,
        seletList2: this.seletList2,
        seletList3: this.seletList3,
        delAnnexFileIdList: this.delAnnexFileIdList,
      };
      arrayList.userId = this.userInfoid;
      this.active = 3;
      this.$parent.next(3, arrayList, this.isEdit).then(res => {
        if (res) {
          this.getInfo()
        }
      })
    }
  },
};
</script>

<style scoped lang="less">
.red {
  background: red;
  color: #fff;
  padding: 3px 6px;
  border-radius: 5px;
}

.green {
  background: rgb(11, 195, 11);
  color: #fff;
  padding: 3px 6px;
  border-radius: 5px;
}

.blue {
  background: #409EFF;
  color: #fff;
  padding: 3px 6px;
  border-radius: 5px;
}

.reform {
  margin: 10px 100px;
  // ::v-deep .el-date-editor--datetimerange.el-input,
  // .el-date-editor--datetimerange.el-input__inner {
  //   width: 370px;
  // }
}

::v-deep .el-dialog__header {
  text-align: left;
}

::v-deep .el-form-item {
  text-align: left;
}

.userInfor {
  margin: 30px 60px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 10px;
  font-size: 15px;
  margin-bottom: 20px;
  font-weight: bold;
}

::v-deep .el-select-dropdown {
  position: absolute !important;
  left: 0 !important;
  top: 35px !important;
}

.el-date-editor {
  width: 100%;
}

::v-deep.el-select {
  width: 100%;
}

.infomation {
  text-align: left;
  margin: 20px 80px;

  // padding: 10px;
  .titleheader {
    font-size: 14px;
    color: #000;
    line-height: 50px;
    border-bottom: 1px solid #f0f0f0;
    padding: 0 20px;
    font-weight: bold;
    margin-top: 20px;
  }

  .infomation_item {
    padding: 10px 20px;

    h2 {
      line-height: 30px;
    }

    p {
      display: flex;
      justify-content: flex-start;
      // line-height: 25px;
      margin: 15px 15px 15px 0;

      span {
        background: #f0f0f0;
        padding: 4px 8px;
        margin-right: 10px;
        border-radius: 4px;
      }
    }
  }
}

::v-deep .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 110px;
}

::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 110px;
}

::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}

// ::v-deep .el-dialog__header {
//   text-align: left;
//   padding: 18px 20px;
//   border-bottom: 1px solid #ebeef5;
//   box-sizing: border-box;
// }
.uploadType {
  // display: flex;
  margin: 10px 110px;

  span {
    font-size: 14px;
    color: #606266;
  }
}

::deep.el-upload-list {
  margin-left: 156px;
}

/deep/.el-table th.el-table__cell {
  background: #f5f7fa;
  color: #000;
}
</style>